import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClientDiaryDataService {
  public diariesChanged = new Subject<void>();

  notifyChanged(): void {
    this.diariesChanged.next();
  }
}
